<template lang="pug">
MarkupForm(
  button-text='Войти',
  :disabled='isDisabled',
  :messages='errorMessage',
  @submit='onSubmit'
)
  FormInput.parts-form-signin__field(
    v-model.trim='email',
    label='Ваш email',
    name='email',
    placeholder='Например, mail@mail.ru',
    :error='errors.length',
    @input='resetError()'
  )
  FormInput.parts-form-signin__field(
    v-model.trim='password',
    label='Ваш пароль',
    name='password',
    placeholder='Ваш пароль',
    type='password',
    :error='errors.length',
    @input='resetError()'
  )
  template(slot='buttons')
    .auth-services(v-if='isEsiaModule && isAuthServices')
      EsiaLink.auth-services_btn
    slot(name='buttons')
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { ACTIONS } from '@/store/user';
import signMixin from '../sign-mixin.js';
import { HASH_SIGNIN } from '@/pages/default/popup/forms/const';
import EsiaLink from '@/components/esialink';
import IsEsiaCheckMixin from '@/mixins/isEsiaCheck';
const { mapActions } = createNamespacedHelpers('user');

export default {
  name: 'ViewDefaultPopupFormSignin',

  mixins: [signMixin, IsEsiaCheckMixin],

  data: () => ({
    email: '',
    password: '',
  }),
  components: { EsiaLink },

  computed: {
    isAuthServices() {
      return (
        (this.$route.hash ? this.$route.hash.substring(1) : '') === HASH_SIGNIN
      );
    },
    requestData() {
      const { email, password } = this;
      return { email, password };
    },

    message() {
      return this.hasErrors
        ? [
            {
              content: 'ВВЕДЕННЫЙ E-MAIL НЕВЕРНЫЙ ИЛИ ПАРОЛЬ НЕ ПОДХОДИТ',
              strong: true,
            },
            'Проверьте правильность или нажмите «Не помню пароль»',
          ]
        : null;
    },
  },

  methods: {
    ...mapActions({ runAction: ACTIONS.SIGNIN }),
  },
};
</script>
<style lang="stylus">
.auth-services{
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 14px;
  font-weight: 700;
  margin-left 6px;

  &_btn{
    font-weight: 600;
    font-size: 14px;
    font-family: 'Open Sans';
    display: -ms-flexbox;
    -ms-flex-align: center;
    align-items: center;
    border: 1px solid #a9a9a9 !important;
    border-radius: 12px;
    cursor: pointer;
    display: flex !important;
    padding: 20px;
    margin: 0 !important;

    &:hover{
      background-color #fff
    }
  }
}
</style>



// WEBPACK FOOTER //
// component.vue?ca13581e